import React, { useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"

import classNames from "classnames"

import { useHydratedFormValues } from "shared/lib/form/useHydratedFormValues"
import { SelectOption } from "shared/types/Select"

import { ProjectPhaseFilterInput } from "./ProjectPhaseFilterInput"
import { ProjectSearchInput } from "./ProjectSearchInput"
import { ProjectSortInput } from "./ProjectSortInput"
import { ProjectsFilterFormData } from "./schema/projectsFilterFormDataSchema"

export interface ProjectsOverviewControlsModel {
  defaultFormData: ProjectsFilterFormData
  projectPhaseFilterOptions: SelectOption<string>[]
  isDisabled?: boolean
  onChange?: (formData: ProjectsFilterFormData) => void
}

export interface ProjectsOverviewControlsProps
  extends ProjectsOverviewControlsModel {
  className?: string
}

export const ProjectsOverviewControls = React.memo(
  ({
    className,
    projectPhaseFilterOptions,
    defaultFormData,
    isDisabled,
    onChange
  }: ProjectsOverviewControlsProps) => {
    const form = useForm<ProjectsFilterFormData>({
      defaultValues: defaultFormData
    })

    useHydratedFormValues(form, defaultFormData)

    useEffect(() => {
      return form.subscribe({
        formState: { values: true },
        callback: ({ values }) => onChange?.(values)
      })
    }, [form.watch, onChange])

    return (
      <FormProvider {...form}>
        <form
          id="projects-overview-controls-form"
          className={classNames("projects-overview-controls", className)}
        >
          <ProjectPhaseFilterInput
            options={projectPhaseFilterOptions}
            disabled={isDisabled}
            className="projects-overview-controls__phase"
          />
          <ProjectSortInput
            disabled={isDisabled}
            className="projects-overview-controls__sort"
          />
          <ProjectSearchInput
            disabled={isDisabled}
            className="projects-overview-controls__search"
          />
        </form>
      </FormProvider>
    )
  }
)
